async function sortPowerTreePaths(powerTrees) {
  return powerTrees.map(powerTree => {
    const { tracePaths, connectPMICPaths = [] } = powerTree;
    const newTracePaths = sortPaths(tracePaths);
    return { ...powerTree, tracePaths: [...newTracePaths, ...connectPMICPaths] }
  })
}

function sortPaths(pathsArray) {
  const generateSortKey = (path) => {
    const reversed = path.slice().reverse();
    const pcbKeyChain = reversed.map(comp => comp.pcbKey);
    const compNameChain = reversed.map(comp => comp.name);

    const lastComp = path[path.length - 1];
    const lastCompKey = lastComp ? [
      lastComp.name,
      lastComp.isGnd ? 1 : 0
    ] : [];

    return { pcbKeyChain: [...new Set(pcbKeyChain)], compNameChain, lastCompKey };
  };

  const comparePaths = (a, b) => {
    const { pcbKeyChain: chainA, compNameChain: compsA, lastCompKey: keyA } = generateSortKey(a);
    const { pcbKeyChain: chainB, compNameChain: compsB, lastCompKey: keyB } = generateSortKey(b);

    if (chainA.length !== chainB.length) {
      return chainA.length - chainB.length
    }
    for (let i = 0; i < chainA.length; i++) {
      const valA = chainA[i];
      const valB = chainB[i];

      if (valA === undefined) return -1;
      if (valB === undefined) return 1;

      const strCompare = String(valA).localeCompare(String(valB));
      if (strCompare !== 0) return strCompare;
    }

    for (let i = 0; i < Math.min(compsA.length, compsB.length); i++) {
      const strCompare = String(compsA[i]).localeCompare(String(compsB[i]));
      if (strCompare !== 0) return strCompare;
    }

    const [nameA, isGndA] = keyA;
    const [nameB, isGndB] = keyB
    const strCompare = String(nameA).localeCompare(String(nameB));
    if (strCompare !== 0) return strCompare;
    if (typeof isGndA === 'number' && typeof isGndB === 'number') {
      if (isGndA !== isGndB) return isGndA - isGndB;
    }
    return 0;
  };

  return [...pathsArray].sort(comparePaths);
}

export {
  sortPowerTreePaths
}